import {AfterViewInit, Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {GeneralSearch} from '../../../../modules/general_search/domain/general-search';
import {GeneralSearchService} from '../../../../modules/general_search/service/general-search.service';

@Component({
  selector: 'app-mobile-general-search-dialog',
  templateUrl: './mobile-general-search-dialog.component.html',
  styleUrls: ['./mobile-general-search-dialog.component.scss'],
  standalone: false
})
export class MobileGeneralSearchDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  filterText = '';
  results: GeneralSearch[] = [];
  isLoading = false;
  hasSearched = false;

  private searchTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private dialogRef: MatDialogRef<MobileGeneralSearchDialogComponent>,
    private generalSearchService: GeneralSearchService,
    private router: Router
  ) {
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput?.nativeElement.focus());
  }

  ngOnDestroy(): void {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  onSearchInput(value: string): void {
    this.filterText = value;
    this.hasSearched = false;

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    const normalizedValue = value.trim();
    if (!normalizedValue) {
      this.results = [];
      this.isLoading = false;
      return;
    }

    this.searchTimeout = setTimeout(() => this.search(normalizedValue), 300);
  }

  searchFirstResult(): void {
    const firstResult = this.results.find(result => result.generalEntity?.length > 0)?.generalEntity[0];
    const route = this.results.find(result => result.generalEntity?.length > 0)?.route;

    if (firstResult && route) {
      this.openResult(route, firstResult.id);
    }
  }

  openResult(route: string, id: string): void {
    this.dialogRef.close();
    this.router.navigate(['/', route, id]);
  }

  close(): void {
    this.dialogRef.close();
  }

  private search(value: string): void {
    this.isLoading = true;

    this.generalSearchService.findByText(value)
      .then(results => this.results = results || [])
      .catch(() => this.results = [])
      .finally(() => {
        this.isLoading = false;
        this.hasSearched = true;
      });
  }
}
